module.exports = __webpack_public_path__ + "img/dsci0144.84fb0898.jpg";